import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CmsContentTypes } from '../interfaces/cms';
import { ContentfulGetterService, IGraphQLRequestCollectionOptions, IGraphQLRequestOptions } from './contentful-getter.service';
import {
  BenefitsCategory,
  IBenefitsItem,
  IBenefitsItemResponse,
  IBenefitsItems,
  IBenefitsResponse,
} from '../interfaces/benefits';
import { BenefitsHelper } from '../utils/helpers/benefits.helper';
import { Options } from '@contentful/rich-text-html-renderer';
import { BLOCKS } from '@contentful/rich-text-types';

export interface IBenefitsCollectionOptions extends IGraphQLRequestCollectionOptions {
  isFeatured?: boolean;
  categories?: BenefitsCategory;
  consultantAccess?: string[];
}

@Injectable(
  { providedIn: 'root' }
)
export class BenefitsContentfulService {

  renderOptions: Options = {
    renderNode: {
      ['paragraph']: (node, next) =>
        `<p>${next(node.content).replace(/\n/g, `</br>`)}</p>`,
      ['hyperlink']: (node, next) =>
      `<a target="_blank" href="${node.data.uri}">${next(node.content)}</a>`,
      [BLOCKS.EMBEDDED_ASSET]: (node, next) => {
        const assetId = node.data.target.sys.id;
        const asset = BenefitsHelper.benefitAssets.get(assetId);

        if (asset && asset.url) {
          return `<img src="${asset.url}" alt="${asset.title || ''}" />`;
        }
        return '';
      }
    }
  };
  constructor(private contentfulGetterService: ContentfulGetterService) {}


  getBenefits$(options: IBenefitsCollectionOptions, previewMode = false): Observable<IBenefitsItems> {
    return this.contentfulGetterService.get<IBenefitsResponse, IBenefitsItems>(
      CmsContentTypes.BenefitItem,
      previewMode,
      BenefitsHelper.getBenefitsHandler,
      {
        ...options
      },
      this.renderOptions
    )
  }

  getBenefitById$(id: string, options: IGraphQLRequestOptions, previewMode = false): Observable<IBenefitsItem> {
    return this.contentfulGetterService.getById<IBenefitsItemResponse, IBenefitsItem>(
      id,
      CmsContentTypes.BenefitItem,
      previewMode,
      BenefitsHelper.getBenefitHandler,
      {
        ...options
      },
      this.renderOptions
    )
  }
}
